<template>
  <div class="d-flex flex-column mb-1">
    <sf-text ref="title" class="two-lines">
      {{ item.productTitle }}
    </sf-text>
    <div class="d-flex justify-space-between text-body-1 text-primary">
      <span ref="quantity">{{ `${item.quantity} x` }}</span>
      <span v-if="item.price" ref="price">
        {{ formatMoneyShowZeroPrice(item.price, true) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfText from '@/components/text/SfText.vue'
import { formatMoneyShowZeroPrice } from '@/modules/product/helpers'
import { OrderItem } from '@/types/index'
import { PropType } from 'vue'

defineProps({
  item: {
    type: Object as PropType<OrderItem>,
    required: true
  }
})
</script>
